import clsx from 'clsx'
import type { ReactElement } from 'react'
import { themeClass } from '~/styles/theme.css'
import { loaderText, wrapper, wrapperSmall } from './Loader.css'
import { LoaderIcon } from './LoaderIcon'

export const Loader = ({
  small = false,
  forceText = false
}: {
  small?: boolean
  forceText?: boolean
}): ReactElement => {
  return (
    <div className={clsx(themeClass, wrapper, small && wrapperSmall)}>
      <LoaderIcon small={small} />
      {(!small || forceText) && (
        <div className={loaderText}>Chargement en cours</div>
      )}
    </div>
  )
}
